var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.$route.name === _vm.client_products_routes.Products)?_c('Products'):(_vm.$route.params.type)?_c('Default_page'):_c('Home')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }